<template>
  <div
    class="antialiased font-sans bg-slate-50 dark:bg-slate-900 text-slate-800 dark:text-slate-200 min-h-screen flex items-center justify-center overflow-hidden"
  >
    <!-- Botón de toggle de tema (esquina superior derecha) -->
    <div class="fixed top-3 md:top-6 right-6 z-50">
      <ThemeToggle />
    </div>

    <div class="fixed inset-0 z-0 flex">
      <div class="hidden lg:block lg:w-3/5 2xl:w-2/3 relative h-full">
        <img
          alt="Luxury Hotel Lobby"
          class="absolute inset-0 w-full h-full object-cover"
          :src="bannerSrc"
        />
        <div
          class="absolute inset-0 bg-gradient-to-r from-black/40 via-black/10 to-slate-50 dark:to-slate-900"
        ></div>
      </div>
      <div
        class="w-full lg:w-2/5 2xl:w-1/3 h-full relative bg-slate-50 dark:bg-slate-900"
      ></div>
    </div>

    <main
      class="login-main relative z-10 w-full max-w-7xl 2xl:max-w-[1840px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-5 items-center min-h-screen"
    >
      <div class="hidden lg:block lg:col-span-3"></div>
        <div class="login-panel-wrap lg:col-span-2 w-full max-w-sm xl:max-w-lg 2xl:max-w-xl mx-auto">
        <div
          class="login-panel bg-white/70 dark:bg-slate-800/70 backdrop-blur-xl border border-white/30 dark:border-slate-700/30 shadow-2xl p-6 xl:p-8 2xl:p-12 rounded-2xl flex flex-col items-center"
        >
          <div class="text-center mb-4">
            <AppLogo :alt="brand.nombre" class="login-logo object-contain w-[160px] xl:w-[190px] 2xl:w-[260px] mx-auto" />
          </div>

          <div class="w-full mb-5 text-center">
            <h2
              class="text-xs xl:text-sm 2xl:text-base uppercase tracking-[0.2em] font-medium text-slate-400 dark:text-slate-500 mb-2"
            >
              Portal de Acceso
            </h2>
            <p
              class="login-title text-lg xl:text-2xl 2xl:text-[2rem] font-serif italic text-slate-700 dark:text-slate-300"
            >
              Bienvenido de nuevo
            </p>
          </div>

          <form @submit.prevent="loginUser" class="login-form w-full space-y-4">
            <div class="space-y-1.5">
              <label
                class="text-[10px] xl:text-xs 2xl:text-xs uppercase tracking-wider font-semibold text-slate-500 dark:text-slate-400 ml-1"
                for="username"
              >
                Usuario
              </label>
              <div class="relative group">
                <i
                  class="login-icon bx bx-user absolute left-4 2xl:left-5 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-custom-primary transition-colors text-xl xl:text-2xl 2xl:text-2xl"
                ></i>
                <input
                  v-model="username"
                  class="login-input w-full pl-11 xl:pl-12 2xl:pl-14 pr-4 py-2.5 xl:py-3.5 2xl:py-4 bg-white/50 dark:bg-black/20 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-custom-primary transition-all outline-none text-sm xl:text-base 2xl:text-lg text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-600"
                  id="username"
                  name="username"
                  placeholder="Ingrese su usuario"
                  type="text"
                  required
                />
              </div>
            </div>

            <div class="space-y-1.5 mb-4">
              <label
                class="text-[10px] xl:text-xs 2xl:text-xs uppercase tracking-wider font-semibold text-slate-500 dark:text-slate-400 ml-1"
                for="password"
              >
                Contraseña
              </label>
              <div class="relative group">
                <i
                  class="login-icon bx bx-lock absolute left-4 2xl:left-5 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-custom-primary transition-colors text-xl xl:text-2xl 2xl:text-2xl"
                ></i>
                <input
                  v-model="password"
                  class="login-input w-full pl-11 xl:pl-12 2xl:pl-14 pr-4 py-2.5 xl:py-3.5 2xl:py-4 bg-white/50 dark:bg-black/20 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-custom-primary transition-all outline-none text-sm xl:text-base 2xl:text-lg text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-600"
                  id="password"
                  name="password"
                  placeholder="••••••••"
                  type="password"
                  required
                />
              </div>
            </div>

            <div v-if="errorMessage" class="mt-4">
              <div
                class="text-red-600 dark:text-red-400 px-2 py-2 rounded-xl text-sm 2xl:text-base"
              >
                {{ errorMessage }}
              </div>
            </div>

            <button
              class="login-submit w-full mt-4 py-2.5 xl:py-3.5 2xl:py-4 bg-custom-primary text-white border-0 font-semibold rounded-xl tracking-widest uppercase text-xs xl:text-sm 2xl:text-lg shadow-lg hover:shadow-blue-600/40 hover:scale-[1.01] active:scale-[0.99] transition-all duration-300 flex items-center justify-center gap-2 group"
              type="submit"
            >
              Iniciar Sesión
              <i
                class="login-submit-icon bx bx-right-arrow-alt text-lg xl:text-xl 2xl:text-2xl group-hover:translate-x-1 transition-transform"
              ></i>
            </button>
          </form>

          <div class="login-footer mt-4 text-center">
            <p
              class="text-[10px] xl:text-xs 2xl:text-sm text-slate-400 uppercase tracking-widest"
            >
              © 2026 {{ brand.nombre }}
            </p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>

import axios from "axios";
import { mapActions } from "vuex";
import { API_URL } from "@/config/config";
import { BRAND } from "@/config/branding";
import ThemeToggle from "@/components/ThemeToggle.vue";
import AppLogo from "@/components/AppLogo.vue";

export default {
  name: "LoginC",
  components: {
    ThemeToggle,
    AppLogo
  },
  data() {
    return {
      brand: BRAND,
      username: "",
      password: "",
      errorMessage: "",
    };
  },
  computed: {
    bannerSrc() {
      // Banner de login por hotel (carpeta VUE_APP_BRAND_LOGO_DIR).
      return require(`@/assets/imagenes/${this.brand.logoDir}/login-banner.webp`);
    },
  },
  methods: {
    ...mapActions(["login"]),
    async loginUser() {
      this.errorMessage = "";

      try {
        const response = await axios.post(
          `${API_URL}/login`,
          {
            Usuario: this.username,
            Contraseña: this.password,
          },
          { withCredentials: true },
        );

        const userData = response.data.usuario;
        this.login(userData);
        this.$router.push("/inicio");
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message ||
          "Error al iniciar sesión. Verifica tus credenciales.";
      }
    },
  },
};
</script>

<style scoped>
@media (min-width: 1024px) and (max-height: 900px) {
  .login-panel {
    padding: 1.75rem;
  }

  .login-logo {
    width: 10.25rem;
  }

  .login-title {
    font-size: 1.75rem;
    line-height: 1.15;
  }

  .login-form > * + * {
    margin-top: 0.875rem;
  }

  .login-input,
  .login-submit {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
    font-size: 1rem;
  }

  .login-input {
    padding-left: 3rem;
  }

  .login-icon,
  .login-submit-icon {
    font-size: 1.25rem;
  }
}
</style>
